'use client';

import Image from 'next/image';
import { Button } from '@components/ui/button';
type AuthAction = 'Sign-in' | 'Sign-up' | 'Password reset' | 'Account verification' | 'Account completion' | 'Document signing';
interface AuthUnavailableProps {
  action: AuthAction;
}
export function AuthUnavailable({
  action
}: AuthUnavailableProps) {
  return <div className="relative mx-auto flex w-full max-w-md flex-col justify-center px-4 py-6 md:px-8 md:py-0" data-sentry-component="AuthUnavailable" data-sentry-source-file="auth-unavailable.tsx">
      <div>
        <Image src="/assets/images/logo.png" className="mx-auto mb-8 h-8 w-8" width={32} height={32} alt="logo" data-sentry-element="Image" data-sentry-source-file="auth-unavailable.tsx" />
        <h1 className="font-ivar text-center text-xl font-normal text-gray-800 md:text-[28px]">
          We&apos;ll be right back
        </h1>
        <p className="mt-4 text-center text-sm text-gray-600">
          {action} is temporarily unavailable. Please try again in a few
          minutes.
        </p>
      </div>
      <div className="mt-8 flex justify-center">
        <Button variant="default" size="lg" onClick={() => window.location.reload()} data-sentry-element="Button" data-sentry-source-file="auth-unavailable.tsx">
          Try again
        </Button>
      </div>
    </div>;
}